"use client";

import { VolumeX } from "lucide-react";
import { Card } from "@/components/ui";
import { VideoAraci } from "@/components/VideoAraci";

export function SessizTool() {
  return (
    <VideoAraci
      calistirEtiket="Sesi kaldır"
      calistirIkon={<VolumeX className="size-4" />}
      ekAd="sessiz"
      komut={() => ({
        // Görüntü yeniden kodlanmaz (hızlı, kayıpsız); yalnızca ses atılır.
        args: ["-i", "girdi", "-c:v", "copy", "-an", "cikti.mp4"],
        uzanti: "mp4",
        mime: "video/mp4",
      })}
      ayarlar={
        <Card>
          <p className="text-sm text-muted">
            Videonun sesi tamamen kaldırılır, görüntü olduğu gibi korunur. Ayar gerekmez — sadece <b>Sesi kaldır</b>&apos;a basın.
          </p>
        </Card>
      }
    />
  );
}
